document.addEventListener("DOMContentLoaded", function () {
    const successMessage = document.querySelector(".success-message");

    if (successMessage) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, 100);
    }
  });